import { taskSeriesIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { loadSeries } from "../tasks/loaders.ts";
import { RecordPending } from "../tasks/pending.tsx";
import { SeriesPage } from "../tasks/series-page.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/tasks/series/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null ? <NoAccessPage /> : <SeriesPage viewer={viewer} seriesId={id} />;
};

export const Route = createFileRoute("/_app/tasks/series/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(taskSeriesIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadSeries(context.data, params.id),
  pendingComponent: () => <RecordPending kind="task" />,
  component: Page,
});
